import { Nonprofit } from "~/models/list";
import Spinner from "~/common/icons/Spinner";
import { ListItemCard } from "./listitem/ListItemCard";

export const ListCards = ({
  listId,
  nonprofits,
}: {
  listId: string;
  nonprofits: Nonprofit[] | undefined;
}) => {
  if (!nonprofits) {
    return (
      <span className="tw:flex tw:flex-row tw:justify-center tw:items-center">
        <Spinner />
      </span>
    );
  }

  return (
    <div className="tw:gap-4 tw:md:grid tw:md:grid-cols-2 tw:xl:grid-cols-3">
      {nonprofits.map((nonprofit: Nonprofit) => (
        <ListItemCard
          key={nonprofit.ein}
          baseUrl={Environment.CN_URL}
          listId={listId}
          ein={nonprofit.ein}
          name={nonprofit.name}
          rating={nonprofit.encompass_score_total_display}
          starRating={nonprofit.encompass_star_rating}
          city={nonprofit.city}
          state={nonprofit.state}
          tags={nonprofit.tags}
          description={nonprofit.nonprofit_response}
        />
      ))}
    </div>
  );
};
